<template>
    <div>
        <header-page></header-page>
        <full-page :options="options" id="fullpage">
            <div class="section" id="section0">
                <div class="slide" id="plateauRepas">
                </div>
            </div>
            <div class="TitleBottom"><a
                    @click="$vuetify.goTo('#welcome',{ duration:1000, offset:0, easing:'easeInOutCubic'})">
                <h1>
                    <v-icon :size="screenwidth" color="white">mdi-chevron-down</v-icon>
                    Pauses et plateaux repas
                </h1>
            </a></div>
        </full-page>
        <div>
            <div class="backgroundGreen" id="welcome">
                <div class="media-row">
                    <div class="row backgroundGreen">
                        <div class="col-12 col-md-8 col-lg-8" style="background:#ddb226;">
                            <div class="item media text-white alignLeft">
                                <div class="media-body align-top">
                                    <div class="desc">
                                        <h2 class="display-5 bottomH2">Les pauses des professionnels</h2>
                                        <p>
                                            Pour l’accueil du matin, le café après le déjeuner ou la pause goûter de
                                            l’après-midi, nous prenons en charge selon vos besoins :
                                        </p>
                                        <p class="pAlpha">
                                        <ul>
                                            <li>
                                                <v-icon size="20" color="white">mdi-checkbox-marked-circle</v-icon>
                                                L’installation sur place d’une table dressée
                                            <li>
                                                <v-icon size="20" color="white">mdi-checkbox-marked-circle</v-icon>
                                                Le service des boissons, chaudes ou froides
                                            </li>
                                            <li>
                                                <v-icon size="20" color="white">mdi-checkbox-marked-circle</v-icon>
                                                Les viennoiseries, gâteaux secs ou pâtisseries
                                            </li>
                                        </ul>
                                        </p>
                                        <h2 class="display-5 bottomH2">La livraison de plateaux repas chauds ou
                                            froids</h2>
                                        <p>
                                            Pour une pause déjeuner gourmande et rythmée, Croustillance livre sur le
                                            lieu de votre événement des plateaux repas individuels, chauds ou froids,
                                            avec tout le nécessaire : couverts, serviettes, sel et poivre.
                                        </p>
                                        <p>
                                            Pour un plaisir préservé, nous servons nos plateaux-repas chauds dans des
                                            <b>boîtes isothermes individuelles</b>, et les plats sont présentés dans de
                                            la <b>vaisselle en porcelaine</b>. Un plus raffiné et écologique.
                                        </p>
                                        <p>Les pauses comme les plateaux repas Croustillance se déclinent en différentes formules, du menu du jour au plateau dégustation, pour satisfaire tous les palais et tous les budgets. </p>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-4 col-lg-4"
                             style="background-image: url('img/plateaux-repas-traiteur/Roulade-chou-fleur.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;">
                            <div class="item media text-white alignLeft">
                                <div class="item media text-white alignLeft">
                                    <div class="media-body align-top">
                                        <div class="desc">
                                            <h3  class="display-6 titleSpacer" style="background-color: #7d2c6fb3;">Nos formules plateaux repas</h3>
                                            <p>
                                            <div class="btns-action sr-up-td3 text-primary">
                                                <a href="pdf/plateaux-repas-chauds.pdf" target="_blank"
                                                   class="btn btn-normal btn-pdf btn-white spaceTop">
                                            <span class="icon">
                            <img src="img/pdf-icone.svg" width="35px">
                          </span>
                                                    <span class="text">Découvrir nos PLATEAUX REPAS CHAUDS</span>
                                                </a>
                                            </div>
                                            <div class="btns-action sr-up-td3 text-primary">
                                                <a href="pdf/plateaux-repas-froids.pdf" target="_blank"
                                                   class="btn btn-normal btn-pdf btn-white spaceTop">
                                            <span class="icon">
                            <img src="img/pdf-icone.svg" width="35px">
                          </span>
                                                    <span class="text">Découvrir nos PLATEAUX REPAS FROIDS</span>
                                                </a>
                                            </div>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="media-row">
                <div class="row backgroundGreen">
                    <div class="col-12 col-md-4 col-lg-4" style="background:#bd7e6d;">
                        <div class="item media text-white alignLeft">
                            <div class="media-body align-top">
                                <div class="desc">
                                    <p style="font-size: 35px; font-family: Nunito, sans-serif; font-weight: bold;">
                                        Croustillance est votre interlocuteur privilégié pour tous les moments de
                                        détente ponctuant vos séminaires, conférences et événements professionnels.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-md-4 col-lg-4"
                         style="background-image: url('img/plateaux-repas-traiteur/dessert-plateau.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;">
                        <div class="item media text-white alignLeft">
                            <div class="media-img">
                                <div class="mask"></div>
                                <img class="img-block" src="img/plateaux-repas-traiteur/dessert-plateau.jpg" alt="dessert des plateaux repas"
                                     style="display: none;">
                                <div class="img"
                                     style="background-image: url('img/plateaux-repas-traiteur/dessert-plateau.jpg'); background-repeat: no-repeat; background-position: center center; background-size: cover;"></div>
                            </div>
                            <div class="media-body align-top">
                                <div class="desc">
                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="col-12 col-md-4 col-lg-4"
                         style="background-color:#818629;">
                        <div class="item media text-white alignLeft">
                            <div class="media-body align-top">
                                <div class="desc">
                                    <h3 class="display-6">Ponctualité et discrétion</h3>
                                    <p>
                                        Nous arrivons à l’heure convenue et nous dressons votre table sans perturber votre activité.
                                    </p>
                                    <h3 class="display-6">Chaud et froid</h3>
                                    <p>
                                        Nos boîtes isothermes individuelles permettent à chacun de déguster nos préparations à la température idéale.
                                    </p>
                                    <h3 class="display-6">
                                        Pause à toute heure</h3>
                                    <p>
                                        Croustillance vous régale à tout moment de la journée ! Un seul impératif : nous confirmer votre commande 48 heures avant la livraison.
                                    </p>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
        <footer-page> </footer-page>
    </div>

</template>

<script>
    import HeaderPage from './headerPage'
    import FooterPage from './footerPage'

    export default {
        name: 'plateau',
        components: {
            HeaderPage,
            FooterPage
        },
        data() {
            return {
                options: {
                    licenseKey: 'A32C7F42-F0FE4A04-AAB7E182-AB1F9C8B',
                    navigation: false,
                    scrollBar: true,
                    autoScrolling: false,
                    fitToSection: false
                }
            }
        },
        methods: {
            afterLoad() {
                console.log('After load')
            },
        },
        computed: {
            screenwidth() {
                if (screen.width > 400) {
                    return 70
                } else {
                    return 30
                }
            }
        },
        created() {
            document.getElementsByTagName('meta')["description"].content = "Croustillance propose différentes formules pour l’accueil du matin, les plateaux-repas chauds ou froids du déjeuner, et la pause goûter de l'après-midi.";
            document.title = " Pauses et plateaux-repas pour les professionnels | Croustillance";
        }
    }
</script>

<style>
    #plateauRepas {
        background: url('/img/plateaux-repas-traiteur/plateaux-repas-entreprise.jpg') no-repeat center center;
        padding: 0 0 0 0;
        background-size: cover;
    }
</style>